import { useMemo } from 'react';

import {
  Configuration,
  RestOfferInstancesApiFactory,
  RestProcessesApiFactory,
  RestProcessesCustomerApiFactory,
  RestProcessesEventBasicApiFactory,
  RestResourcesNoteApiFactory,
  RestResourcesThreadApiFactory,
  RestResourcesTimelineMessagesApiFactory,
} from '@/api/generated';
import { CONFIG } from '@/config/config.ts';

import { useAxiosInstance } from '../useAxiosInstance.util.tsx';

interface Return {
  offerInstancesApi: ReturnType<typeof RestOfferInstancesApiFactory>;
  processesApi: ReturnType<typeof RestProcessesApiFactory>;
  processesCustomerApi: ReturnType<typeof RestProcessesCustomerApiFactory>;
  processesEventBasicApi: ReturnType<typeof RestProcessesEventBasicApiFactory>;
  resourceNoteApi: ReturnType<typeof RestResourcesNoteApiFactory>;
  resourceThreadApi: ReturnType<typeof RestResourcesThreadApiFactory>;
  resourceTimelineMessagesApi: ReturnType<typeof RestResourcesTimelineMessagesApiFactory>;
}

export const useProcessApiClient = (): Return => {
  const basePath = CONFIG.HOST;
  const configuration = useMemo(() => getConfiguration(basePath), [basePath]);
  const axiosInstance = useAxiosInstance();

  return useMemo(() => {
    return {
      offerInstancesApi: RestOfferInstancesApiFactory(configuration, undefined, axiosInstance),
      processesApi: RestProcessesApiFactory(configuration, undefined, axiosInstance),
      processesCustomerApi: RestProcessesCustomerApiFactory(
        configuration,
        undefined,
        axiosInstance,
      ),
      processesEventBasicApi: RestProcessesEventBasicApiFactory(
        configuration,
        undefined,
        axiosInstance,
      ),
      resourceNoteApi: RestResourcesNoteApiFactory(configuration, undefined, axiosInstance),
      resourceThreadApi: RestResourcesThreadApiFactory(configuration, undefined, axiosInstance),
      resourceTimelineMessagesApi: RestResourcesTimelineMessagesApiFactory(
        configuration,
        undefined,
        axiosInstance,
      ),
    };
  }, [axiosInstance, configuration]);
};

const getConfiguration = (basePath: string): Configuration => ({
  basePath,
  isJsonMime(_mime: string): boolean {
    return true;
  },
});
